import axiosInstance from "services/AxiosInstance";
import { ResponseType, TUser } from "types";

import { UserInterface } from "../types/UserDto";

export const postUserService = async (payLoad: UserInterface): Promise<ResponseType<TUser>> => {
  const response = await axiosInstance.post(`users`, payLoad);
  return response.data;
};
